<template>
  <v-chart
    v-if="data && data.total"
    :option="option"
    autoresize
    class="offline-chart"
  />
</template>

<script>
export default {
    props: {
        data: { type: Object, required: true },
        successOfflineSelected: { type: Boolean, required: false},
        failOfflineSelected: { type: Boolean, required: false},
    },
    data: () => ({
        option: {
            width: '92%',
            height: '80%',
            legend: {
                show: false,
                left: 'center',
                top: '0',
                textStyle: {
                    fontSize: 14,
                    color: '#809FB8',
                    fontWeight: 'bold'
                },
                data: [],
                selected: {}
            },
            xAxis: {
                // boundaryGap: false,
                axisLine: {
                    onZero: true,
                    lineStyle: {
                        color: '#809FB8'
                    },
                    textStyle: {
                        color: 'red'
                    }
                },
                axisTick: {
                    lineStyle: {
                        color: 'transparent'
                    },
                },
                alignTicks: true,
                type: 'category',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: 'rgb(217, 225, 231)',
                        opacity: 0.6
                    }
                        
                },
                data: []
            },
            grid: {
                left: '4%',
                right: '96%',
                top: 20,
            },
            yAxis: {
                axisLabel: {
                    formatter: (num) => Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'K' : Math.sign(num)*Math.abs(num)
                },
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#809FB8'
                    }
                },
                nameTextStyle: {
                    color: '#809FB8'
                },
                axisTick: {
                    lineStyle: {
                        color: '#809FB8'
                    }
                },
                splitLine: {
                    show: false
                },
                nameGap: 15
            },
            tooltip: {
                trigger: 'axis',
                textStyle: {
                    fontFamily: 'weborama',
                    fontSize: 16,
                }
            },
            series: []
        }
    }),
    watch: {
        successOfflineSelected(value) {
            this.option.legend.selected.Success = value
            if (!value && this.failOfflineSelected && this.data.failed > 0) {
                const xAxisData = []
                xAxisData.push(...Object.keys(this.data.failed))
                this.option.xAxis.data = xAxisData.sort()
            } else if (value && this.failOfflineSelected && this.data.failed > 0) {
                this.option.xAxis.data = [...new Set([...Object.keys(this.data.success), ...Object.keys(this.data.failed)].sort())]
            }
        },
        failOfflineSelected(value) {
            this.option.legend.selected.Fail = value
            if (!value && this.successOfflineSelected && this.data.success > 0) {
                const xAxisData = []
                xAxisData.push(...Object.keys(this.data.success))
                this.option.xAxis.data = xAxisData.sort()
            } else if (value && this.successOfflineSelected && this.data.success > 0) {
                this.option.xAxis.data =  [...new Set([...Object.keys(this.data.success), ...Object.keys(this.data.failed)].sort())]
            }
        },
    },
    mounted() {
        this.chartData()
    },
    methods: {
        chartData() {
            const xAxisData = []
            const legend = {
                data: [],
                selected: {}
            }
            const defaultSeriesOption = {
                type: 'line',
                symbolSize: 7,
                sampling: 'average',
            }
            if(this.data?.total?.failed > 0) {
                xAxisData.push(...Object.keys(this.data.failed))
                this.option.series.push({
                    name: 'Fail',
                    data: [...new Set(Object.entries(this.data.failed))],
                    ...defaultSeriesOption,
                    color: '#d73c41',
                })
                legend.data.push('Fail')
                legend.selected = {...legend.selected, Fail: this.failOfflineSelected }
                this.option.legend = {...this.option.legend, ...legend}
            }
            if(this.data?.total?.success > 0) {
                xAxisData.push(...Object.keys(this.data.success))
                this.option.series.push({
                    name: 'Success',
                    data: Object.entries(this.data.success),
                    ...defaultSeriesOption,
                    color: '#77b22a',
                })
                legend.data.push('Success')
                legend.selected = {...legend.selected, Success: this.successOfflineSelected }
                this.option.legend = {...this.option.legend, ...legend}

            }

            this.option.xAxis.data = [...new Set(xAxisData.sort())]
        },
    }
}
</script>
<style lang="scss" scoped>
.offline-chart {
  height: 300px;
  width: 100%;
}
</style>